import Emoji from '@/components/Emoji'
import { getCustomEmoji } from '@/atoms/emojis'
import { emojis, shortcodeToEmoji } from '@tiptap/extension-emoji'
import { NodeViewRendererProps, NodeViewWrapper } from '@tiptap/react'
import { useMemo } from 'react'

export default function EmojiNode(props: NodeViewRendererProps) {
  const emoji = useMemo(() => {
    const name = props.node.attrs.name
    const emoji = getCustomEmoji(name)
    return emoji || shortcodeToEmoji(name, emojis)?.emoji
  }, [props.node.attrs.name])

  if (!emoji) {
    return null
  }

  if (typeof emoji === 'string') {
    return (
      <NodeViewWrapper className="inline">
        <span>{emoji}</span>
      </NodeViewWrapper>
    )
  }

  return (
    <NodeViewWrapper className="inline">
      <Emoji emoji={emoji} classNames={{ img: 'mb-1' }} />
    </NodeViewWrapper>
  )
}
